import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faTicketAlt } from '@fortawesome/free-solid-svg-icons';

/**
 * Modal de confirmación para completar una incidencia y cerrar sus tickets
 */
const TagCompleteModal = ({
  itemToComplete,
  isCompleting,
  isDark,
  onClose,
  onConfirm
}) => {
  if (!itemToComplete) return null;

  return (
    <div
      className="modal d-block"
      style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1060 }}
      tabIndex="-1"
    >
      <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '460px' }}>
        <div
          className="modal-content border shadow-lg"
          style={{
            backgroundColor: isDark ? '#182635' : '#ffffff',
            borderColor: isDark ? '#233142' : '#cbd5e1'
          }}
        >
          <div className="modal-body px-4 py-4 text-center">
            <div
              className="rounded-circle mx-auto d-flex align-items-center justify-content-center mb-3 text-success"
              style={{
                width: '52px',
                height: '52px',
                backgroundColor: isDark ? 'rgba(16, 185, 129, 0.15)' : '#d1fae5'
              }}
            >
              <FontAwesomeIcon icon={faCheckCircle} style={{ fontSize: '1.4rem' }} />
            </div>
            <h6 className="fw-bold mb-1" style={{ color: isDark ? '#f9fafd' : '#0f172a' }}>
              Resolver Incidencia
            </h6>
            <div className="small fw-semibold mb-3 text-primary" style={{ fontSize: '0.92rem' }}>
              "{itemToComplete.vNombre}"
            </div>

            {/* Tarjeta de conteo de tickets vinculados */}
            <div
              className="p-3 rounded-3 border mb-3 text-start d-flex align-items-center justify-content-between"
              style={{
                backgroundColor: isDark ? '#101c26' : '#f8fafc',
                borderColor: isDark ? '#233142' : '#e2e8f0'
              }}
            >
              <div className="d-flex align-items-center gap-2">
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center"
                  style={{
                    width: '36px',
                    height: '36px',
                    backgroundColor: isDark ? 'rgba(99, 102, 241, 0.18)' : '#e0e7ff',
                    color: '#6366f1'
                  }}
                >
                  <FontAwesomeIcon icon={faTicketAlt} style={{ fontSize: '0.9rem' }} />
                </div>
                <div>
                  <div className="small fw-bold" style={{ color: isDark ? '#f9fafd' : '#0f172a' }}>
                    Tickets vinculados
                  </div>
                  <div className="text-muted" style={{ fontSize: '0.74rem' }}>
                    Asociados a esta incidencia
                  </div>
                </div>
              </div>

              <span
                className="badge rounded-pill px-3 py-2 fw-bold"
                style={{
                  backgroundColor: (itemToComplete.iTotalTickets || 0) > 0 ? '#6366f1' : '#64748b',
                  color: '#ffffff',
                  fontSize: '0.88rem'
                }}
              >
                {itemToComplete.iTotalTickets || 0}
              </span>
            </div>

            <p className="small text-muted mb-4" style={{ fontSize: '0.82rem', textAlign: 'center' }}>
              Al resolver esta incidencia, se marcará su estado como resuelta y se cerrarán automáticamente los {itemToComplete.iTotalTickets} ticket(s) vinculados.
            </p>

            <div className="d-flex align-items-center justify-content-center gap-2">
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary rounded-pill px-3 shadow-none"
                onClick={onClose}
                disabled={isCompleting}
              >
                Cancelar
              </button>
              <button
                type="button"
                className="btn btn-sm btn-success rounded-pill px-4 shadow-none fw-semibold d-flex align-items-center gap-1.5"
                onClick={onConfirm}
                disabled={isCompleting}
                style={{ backgroundColor: '#10b981', borderColor: '#10b981' }}
              >
                {isCompleting ? (
                  <>
                    <span className="spinner-border spinner-border-sm" role="status" />
                    <span>Resolviendo...</span>
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faCheckCircle} />
                    <span>Confirmar y Resolver</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TagCompleteModal;
